'use client'

import { AppAccessTokenProvider } from '@/src/context/app-access-token/app-access-token-context'
import { CategoryProvider } from '@/src/context/category/category-context'
import { CustomerProvider } from '@/src/context/customer/customer-context'
import { MerchantProvider } from '@/src/context/merchant/merchant-context'
import { MessageProvider } from '@/src/context/message/message-context'
import { PromotionProvider } from '@/src/context/promotion/promotion-context'
import { ShoppingCartProvider } from '@/src/context/shopping-cart/shopping-cart-context'
import React, { ReactNode, useEffect, useState } from 'react'
import SessionWrapper from '../../session-wrapper'
import AllowCookiesLayout from './allow-cookies-layout/allow-cookies-layout'
import { GoogleAnalyticsProvider } from '@/src/context/google-analytics/google-analytics-context'

interface Props {
    children: ReactNode
}

export default function MainLayout(props: Props) {

    const [isCookiesEnabled, setIsCookiesEnabled] = useState<boolean>()
    const [isMounted, setIsMounted] = useState<boolean>()

    useEffect(() => {
        setIsMounted(true)
        if (typeof navigator !== 'undefined' && 'cookieEnabled' in navigator)
            setIsCookiesEnabled(navigator.cookieEnabled)
    }, [])

    if (!isMounted)
        return null

    if (isCookiesEnabled === false)
        return <AllowCookiesLayout />

    return (
        <GoogleAnalyticsProvider>
            <SessionWrapper>
                <AppAccessTokenProvider>
                    <ShoppingCartProvider>
                        <CustomerProvider>
                            <MerchantProvider>
                                <PromotionProvider>
                                    <CategoryProvider>
                                        <MessageProvider>
                                            {props.children}
                                        </MessageProvider>
                                    </CategoryProvider>
                                </PromotionProvider>
                            </MerchantProvider>
                        </CustomerProvider>
                    </ShoppingCartProvider>
                </AppAccessTokenProvider >
            </SessionWrapper>
        </GoogleAnalyticsProvider>
    )
}
